import { useState, useCallback } from 'react';
import { ToastItem } from '../components/common/ToastContainer';
import { ToastType } from '../components/common/Toast';

export const useToast = () => {
	const [toasts, setToasts] = useState<ToastItem[]>([]);

	const showToast = useCallback((message: string, type: ToastType) => {
		const id = Math.random().toString(36).substr(2, 9);
		const newToast: ToastItem = { id, message, type };

		setToasts((prev) => [...prev, newToast]);
	}, []);

	const removeToast = useCallback((id: string) => {
		setToasts((prev) => prev.filter((toast) => toast.id !== id));
	}, []);

	const success = useCallback((message: string) => showToast(message, 'success'), [showToast]);
	const error = useCallback((message: string) => showToast(message, 'error'), [showToast]);
	const info = useCallback((message: string) => showToast(message, 'info'), [showToast]);
	const warning = useCallback((message: string) => showToast(message, 'warning'), [showToast]);

	return {
		toasts,
		showToast,
		removeToast,
		success,
		error,
		info,
		warning,
	};
};
